import { DocumentService } from './document.service';
import { Observable, throwError } from 'rxjs';
import {
  DocumentAdded,
  DocumentRemoved,
  DocumentModified,
} from './document.actions';
import { ShowErrorMessage } from '../notification/notification.actions';
import { Injectable } from '@angular/core';
import {
  WithoutMeta,
  DxDocument
} from '@digitaix/types';

@Injectable()
export class DocumentServiceMock<
  D extends DxDocument,
  Query
> extends DocumentService<D, Query> {
  public static Load = new Map<string, Observable<any[]>>();
  public static Subscribe = new Map<
    string,
    Observable<
      | DocumentAdded<any>
      | DocumentRemoved
      | DocumentModified<any>
      | ShowErrorMessage
    >
  >();
  public static Create = new Map<string, Observable<any>>();
  public static Delete = new Map<string, Observable<any>>();
  public static Update = new Map<string, Observable<any>>();
  public static Get = new Map<string, Observable<any>>();
  public static GetMany = new Map<string, Observable<any[]>>();

  create(
    collectionPath: string,
    document: WithoutMeta<D>,
    documentId?: string,
  ): Observable<D> {
    if (DocumentServiceMock.Create.has(collectionPath)) {
      return DocumentServiceMock.Create.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }

  delete(collectionPath: string, documentId: string): Observable<boolean> {
    if (DocumentServiceMock.Delete.has(collectionPath)) {
      return DocumentServiceMock.Delete.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }

  get(collectionPath: string, documentId: string): Observable<D | null> {
    if (DocumentServiceMock.Get.has(collectionPath)) {
      return DocumentServiceMock.Get.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }

  getMany(collectionPath: string, documentIds: string[]): Observable<D[]> {
    if (DocumentServiceMock.GetMany.has(collectionPath)) {
      return DocumentServiceMock.GetMany.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }

  load(collectionPath: string, query?: Query): Observable<D[]> {
    if (DocumentServiceMock.Load.has(collectionPath)) {
      return DocumentServiceMock.Load.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }

  subscribe(
    collectionPath: string,
    query?: Query,
  ): Observable<
    DocumentAdded<D> | DocumentRemoved | DocumentModified<D> | ShowErrorMessage
  > {
    if (DocumentServiceMock.Subscribe.has(collectionPath)) {
      return DocumentServiceMock.Subscribe.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }

  update(
    collectionPath: string,
    documentId: string,
    document: Partial<WithoutMeta<D>>,
  ): Observable<D> {
    if (DocumentServiceMock.Update.has(collectionPath)) {
      return DocumentServiceMock.Update.get(collectionPath);
    } else {
      return throwError(new Error('404'));
    }
  }
}

export function provideMockDocumentService() {
  return {
    provide: DocumentService,
    useClass: DocumentServiceMock,
  };
}
